"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrapper = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Text_1 = require("../Text/Text");
var InputWrapper_styles_1 = __importDefault(require("./InputWrapper.styles"));
function InputWrapper(_a) {
    var className = _a.className, label = _a.label, children = _a.children, required = _a.required, id = _a.id, error = _a.error, description = _a.description, themeOverride = _a.themeOverride, _b = _a.labelElement, labelElement = _b === void 0 ? 'label' : _b, others = __rest(_a, ["className", "label", "children", "required", "id", "error", "description", "themeOverride", "labelElement"]);
    var classes = InputWrapper_styles_1.default({ theme: theme_1.useMantineTheme(themeOverride) });
    var labelProps = labelElement === 'label' ? { htmlFor: id } : {};
    var inputLabel = react_1.createElement(labelElement, __assign(__assign({}, labelProps), { className: classes.label }), react_1.default.createElement(react_1.default.Fragment, null,
        label,
        required && (react_1.default.createElement("span", { "data-mantine-required": true, className: classes.required },
            ' ',
            "*"))));
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.inputWrapper, className) }, others),
        label && inputLabel,
        description && (react_1.default.createElement(Text_1.Text, { themeOverride: themeOverride, "data-mantine-description": true, color: "gray", size: "xs", className: classes.description }, description)),
        children,
        typeof error !== 'boolean' && error && (react_1.default.createElement(Text_1.Text, { themeOverride: themeOverride, "data-mantine-error": true, color: "red", size: "sm", className: classes.error }, error))));
}
exports.InputWrapper = InputWrapper;
InputWrapper.displayName = '@mantine/core/InputWrapper';
